import authSlice from "./slice/authSlice";

const reducers = {
  auth: authSlice
};

export default reducers;
